export const PERIOD_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: '7d', label: '7 Days' },
  { value: 'month', label: 'This Month' },
  { value: 'quarter', label: 'This Quarter' },
  { value: 'custom', label: 'Custom Range' },
]

export const comparisonPeriodForGlobal = (period) => {
  if (period === 'today') return 'today'
  if (period === 'month') return 'month'
  if (period === 'quarter') return 'quarter'
  if (period === 'custom') return 'custom'
  return 'week'
}

export const isCustomPeriodPending = (period, start, end) =>
  period === 'custom' && !(start && end)

export const mapGlobalPeriodToSectionFilters = (period) => {
  if (period === 'custom') {
    return { globalPeriod: period }
  }
  return {
    globalPeriod: period,
    globalStart: '',
    globalEnd: '',
    salesRange: period,
    salesStart: '',
    salesEnd: '',
    outletRange: period,
    partnerRange: period,
    categoryPeriod: period,
    fastPeriod: period,
    comparisonPeriod: comparisonPeriodForGlobal(period),
  }
}

export const mapGlobalCustomRangeToSectionFilters = ({ start, end }) => ({
  globalPeriod: 'custom',
  globalStart: start,
  globalEnd: end,
  salesRange: 'custom',
  salesStart: start,
  salesEnd: end,
  outletRange: 'custom',
  partnerRange: 'custom',
  categoryPeriod: 'custom',
  fastPeriod: 'custom',
  comparisonPeriod: 'custom',
})
